import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Button, Checkbox, Drawer, Input, message, Spin } from "antd";
import {
  ArrowLeftOutlined,
  EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { baseUrl } from "../../constant/Api";
import TimeShower from "../../components/TimeShower";
import { updateProfile } from "../../actions/profile";
import Terms from "./terms/Terms";
import {
  checkValue,
  convertNumToEn,
  errorMessageHandler,
  Log,
  logType,
  sendEmbedToken,
  tokenHandle,
} from "../../constant/helper";
import { privacyUrl, termsUrl } from "../../constant/Types";
// import LoginSocialMedia from "./loginSocialMedia/LoginSocialMedia";
import { useLocation } from "react-router-dom";

let isLogin = () => false;
let waitTimeDelay = 1000 * 60;

const Form = ({ loading, setLoading, agree, setAgree }) => {
  const [status, setStatus] = useState({
    state: calculateTimeLeft() > 0 ? Status.code : Status.phone,
    waitTime: calculateTimeLeft(),
  });
  const [phone, setPhone] = useState(fetchPhoneSaved());
  const [code, setCode] = useState("");
  const [showTermsDrawer, setShowTermsDrawer] = useState(false);
  const dispatch = useDispatch();
  const { search } = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [loadingButton, setLoadingButton] = useState(false);

  function agreeOnChange(e) {
    setAgree(e.target.checked);
  }

  function handleKeyPress(event) {
    if (event.key === "Enter") {
      register();
    }
  }

  function register() {
    if (!isValid()) {
      return false;
    }
    setLoading(true);

    if (status.state === Status.phone) {
      registerPhone();
    } else if (status.state === Status.code) {
      registerCode();
    }
  }

  function registerPhone() {
    setCode("");
    setLoading(true);

    axios
      .post(
        baseUrl + "public/v1/user/register",
        {
          mobile: convertNumToEn(phone.toString()),
          registrationType: "SMS_OTP",
          tag: "client",
        },
        {
          headers: defaultHeader,
        }
      )
      .then(() => {
        setLoading(false);
        setStatus({ state: Status.code, waitTime: waitTimeDelay });
        message.success("کد ارسال شده به شماره موبایل را وارد نمایید");
        localStorage.setItem("waiting-sms", new Date().toString());
        localStorage.setItem("user-phone", phone);
      })
      .catch((err) => {
        // if (
        //   err.response &&
        //   err.response.data &&
        //   err.response.data.message
        // ) {
        //   message.error(err.response.data.message);
        // } else {
        //   message.error("خطا در ارسال اطلاعات");
        // }
        message.error(errorMessageHandler(err));
        Log(err, logType.error);
        setLoading(false);
      });
  }

  function registerCode() {
    // axios;
    // .post(
    //   baseUrl + ApiUrl.register.phoneCode_post,
    //   {
    //     mobile: phone,
    //     activation_code: code,
    //     regType: "SMS_OTP",
    //   },
    //   {
    //     headers: defaultHeader,
    //   }
    // )
    // .then(() => {
    dispatch(
      updateProfile({
        mobile: phone,
        password: code,
      })
    );
    sessionStorage.setItem("phone", phone);
    sessionStorage.setItem("code", code);

    tokenHandle()
      .then((r) => Log(r))
      .catch((e) => Log(e));
    // })
    // .catch((err) => {
    //   Log(err, logType.error);
    //   setLoading(false);
    //   if (err.response && err.response.data && err.response.data.message) {
    //     const { message: text } = err.response.data;
    //     message.error(text);
    //   } else {
    //     message.error("خطا در ارسال اطلاعات");
    //   }
    // });
  }

  function isValid() {
    if (!agree) {
      message.warn("لطفا قوانین و سیاست حفظ حریم‌ خصوصی را قبول فرمائید");
      return false;
    }

    switch (status.state) {
      case Status.phone:
        const mobileRegex = new RegExp("^(09)\\d{9}$");
        if (!phone || phone.length < 10 || !mobileRegex.test(phone)) {
          message.warn(" شماره را چک کنید ");
          return false;
        }

        return true;
      case Status.code:
        if (!code || code.length < 4) {
          message.warn(" کد تایید را چک کنید ");
          return false;
        }
        return true;
      default:
        return false;
    }
  }

  function handleBackToRegister() {
    setStatus({
      state: Status.phone,
      waitTime: 0,
    });
    localStorage.removeItem("waiting-sms");
    localStorage.removeItem("user-phone");
  }

  function calculateTimeLeft() {
    const wt = localStorage.getItem("waiting-sms");
    if (checkValue(wt)) {
      let difference = new Date().getTime() - new Date(wt).getTime();
      if (difference <= waitTimeDelay) {
        return waitTimeDelay - difference;
      } else {
        localStorage.removeItem("waiting-sms");
        localStorage.removeItem("user-phone");
      }
    }
    return 0;
  }

  function fetchPhoneSaved() {
    const timeLeft = calculateTimeLeft();

    if (timeLeft > 0) {
      return localStorage.getItem("user-phone");
    }

    return "";
  }

  useEffect(() => {
    if (isLogin()) {
      const searchParams = new URLSearchParams(window.location.search);
      const _continue = decodeURI(searchParams.get("continue") || "/home");
      window.location.pathname = _continue;
      sendEmbedToken(searchParams);
    }
  }, []);

  useEffect(() => {
    let interval;
    if (status.waitTime > 0) {
      if (status.state !== Status.code) {
        setStatus(Status.code);

        const ph = localStorage.getItem("user-phone");
        if (checkValue(ph)) {
          setPhone(ph);
        }
      }
      interval = setInterval(() => {
        setStatus({ ...status, waitTime: calculateTimeLeft() });
      }, 1000);
    } else if (status.waitTime < 0) {
      setStatus({ ...status, waitTime: 0 });
    }
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [status.state]);

  useEffect(() => {
    setTimeout(() => {
      setMobileFromQS();
    }, 1000);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setMobileFromQS();
    // eslint-disable-next-line
  }, [search]);

  function setMobileFromQS() {
    let searchParams = new URLSearchParams(search);
    if (searchParams.has("mobile")) {
      let m = searchParams.get("mobile");
      if (phone !== m) {
        setPhone(m);
      }
    }
  }

  const onCloseTermsDrawer = () => setShowTermsDrawer(false);

  return (
    <>
      <div className={"login-form"}>
        <h1 className="title">به لاوین خوش آمدید</h1>
        <small className="sub-title">دفتر مجازی وکلای دادگستری ایران</small>
        <div className="input-holder">
          <Input
            id="mobile-input"
            autoFocus
            autocomplete="one-time-code"
            name={"mobile"}
            value={phone}
            onChange={(e) =>
              setPhone(convertNumToEn(e.target.value.trim()).replace(/\D/g, ""))
            }
            disabled={loading || status.state !== Status.phone}
            suffix={
              // status === Status.code && waitTime === 0 ? (
              status.state === Status.code ? (
                <EditOutlined onClick={handleBackToRegister} />
              ) : (
                <span />
              )
            }
            onKeyPress={handleKeyPress}
            placeholder="شماره موبایل خود را وارد فرمایید"
            max={11}
            maxLength={11}
            minLength={11}
          />
          <div className="code-input-holder">
            {status.state === Status.code && (
              <Input
                autoFocus
                disabled={loading}
                value={code}
                onChange={(e) =>
                  setCode(convertNumToEn(e.target.value).replace(/\D/g, ""))
                }
                onKeyPress={handleKeyPress}
              />
            )}

            {status.waitTime > 0 && status.state === Status.code && (
              <div className="wait-time">
                <span className="key"> ارسال کد فعال سازی: </span>
                <span className="time">
                  {" "}
                  <TimeShower time={status.waitTime / 1000} />{" "}
                </span>
              </div>
            )}
            {status.waitTime === 0 && status.state === Status.code && (
              <div className="wait-time">
                <Button type={"link"} onClick={registerPhone}>
                  ارسال مجدد کد فعال سازی
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="form-footer">
          {status.state === Status.phone && (
            <div className="check-box-accept">
              <Checkbox
                name="check-box"
                checked={agree}
                onChange={agreeOnChange}
                className="check-box-accept-circle"
              >
                با{" "}
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(termsUrl);
                  }}
                  style={{
                    textDecoration: "underline",
                    color: "blue",
                  }}
                >
                  قوانین و مقررات{" "}
                </span>
                و{" "}
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(privacyUrl);
                  }}
                  style={{
                    textDecoration: "underline",
                    color: "blue",
                  }}
                >
                  سیاست حفظ حریم‌ خصوصی
                </span>{" "}
                موافقم
              </Checkbox>

              <div className="show-terms">
                <Drawer
                  className="terms-drawer"
                  title="قوانین و مقررات"
                  placement="bottom"
                  closable={true}
                  onClose={onCloseTermsDrawer}
                  visible={showTermsDrawer}
                  height="100vh"
                >
                  <Terms setShowTermsDrawer={onCloseTermsDrawer} />
                </Drawer>
              </div>
            </div>
          )}
          <div className="control-button center-flex">
            <Button
              type="primary"
              icon={
                loadingButton ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: 24, color: "#fff" }}
                        spin
                      />
                    }
                  />
                ) : (
                  <ArrowLeftOutlined />
                )
              }
              onClick={register}
              disabled={loading}
              loading={loading}
            />
          </div>
        </div>
      </div>
      {status.state === Status.phone && (
        <>
          {/* <Divider>یا</Divider> */}
          {/* <LoginSocialMedia agree={agree} setLoading={setLoadingButton} /> */}
        </>
      )}
    </>
  );
};

const defaultHeader = {
  Accept: "application/json",
  lang: "fa",
};

const Status = {
  phone: 0,
  code: 1,
};

const connected = connect(null, { updateProfile })(Form);
export default connected;
